import React, { Component } from 'react';
import { LazyImage, VideoPlayer } from 'v1/components/shared';
import { chain, get, isEmpty, size } from 'lodash';
import { cleanUrl, isImageFromURL, isVideoFromURL } from 'v1/helpers/misc';
import { convertImageFileWithCloudinary } from 'lib/media/imageHelper';
import classnames from 'classnames';

import { makeFileURL } from 'lib/s3/s3Helper';
import './MediaCarousel.scss';
import {
  convertVideoFileWithCloudinary,
  getVideoCoverImage
} from 'lib/media/videoHelper';

export class MediaCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      media: props.media || [],
      previousMediaSize: size(props.media),
      assetDimensions: []
    };
  }
  componentDidMount = () => {
    this.setState({ loaded: true });
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (size(this.props.media) !== size(nextProps.media)) {
      this.setState({ media: nextProps.media });
    }
  }
  renderMediaType = (media, index) => {
    const { layout } = this.props;
    let mediaItem;
    if (isEmpty(media)) return;
    switch (media.pin_type) {
      case 'youtube/video':
      case 'vimeo/video':
      case 'video/mp4':
      case 'video/mov':
      case 'video/mkv':
      case 'video/mpeg':
      case 'video/ogv':
      case 'video/webm':
      case 'video/wmv':
      case 'video/avi':
      case 'video/quicktime':
      case 'video/x-ms-wmv':
        const coverImage = getVideoCoverImage(media.url);
        const videoUrl = media.file
          ? convertVideoFileWithCloudinary(media.url)
          : media.url;
        mediaItem = (
          <VideoPlayer
            className={classnames(['MediaCarousel-video', layout])}
            key={index}
            src={videoUrl}
            coverImage={coverImage}
            settings={{
              showPreview: true,
              responsive: layout === 'INLINE',
              disableControls: true
            }}
            onClick={() => {
              this.props.onClick?.(index);
            }}
          />
        );
        break;
      case 'instagram/image':
      case 'image/jpg':
      case 'image/jpeg':
      case 'image/png':
      case 'image/gif':
      case 'image/webp':
      case 'image/heic':
      case 'image/tif':
      case 'image/avif':
      case 'image/bmp':
        const pinFile = get(media, 'file', null);
        const url = pinFile ? makeFileURL(pinFile) : media.url;
        const resizedUrl = convertImageFileWithCloudinary(media.url);
        mediaItem =
          layout === 'FILL' ? (
            <span
              className="MediaCarousel-item-imageFill"
              style={{ backgroundImage: `url('${resizedUrl}')` }}
              onClick={() => {
                this.props.onClick?.(index);
              }}
            />
          ) : (
            <div className="tailwind-root contents">
              <LazyImage
                key={index}
                src={[resizedUrl, url]}
                width="100%"
                alt=""
                onClick={() => {
                  this.props.onClick?.(index);
                }}
              />
            </div>
          );
        break;
      case 'file':
        const formattedMedia = {
          pin_type: get(media, 'file.mime_type'),
          url: makeFileURL(media.file),
          file: media.file
        };
        return this.renderMediaType(formattedMedia, index);
      case 'external_link':
        if (media.file) {
          const formattedMedia = {
            pin_type: get(media, 'file.mime_type'),
            url: makeFileURL(media.file),
            file: media.file
          };
          return this.renderMediaType(formattedMedia, index);
        }
        const pinURL = media.url;
        if (isImageFromURL(pinURL)) {
          let extension = cleanUrl(pinURL).split('.').pop();
          extension = extension.toLowerCase();
          const formattedMedia = {
            pin_type: `image/${extension}`,
            url: pinURL
          };
          return this.renderMediaType(formattedMedia, index);
        }
        if (isVideoFromURL(pinURL)) {
          let extension = cleanUrl(pinURL).split('.').pop();
          extension = extension.toLowerCase();
          const formattedMedia = {
            pin_type: `video/${extension}`,
            url: pinURL
          };
          return this.renderMediaType(formattedMedia, index);
        }
        break;
      default:
        break;
    }
    return (
      <span
        className={classnames(['MediaCarousel-item', layout])}
        key={index}
        name={`media-${index}`}
      >
        {mediaItem ?? (
          <div className="tailwind-root contents">
            <div className="flex min-h-[300px] items-center justify-center text-sm">
              <div className="py-2 px-4 inline-block rounded-full bg-gray-500 text-gray-300">
                Preview unavailable
              </div>
            </div>
          </div>
        )}
      </span>
    );
  };
  renderSlider() {
    const { media, layout } = this.props;
    let galleryList = chain(media)
      .filter(p => !p.archived)
      .orderBy(['order', 'asc'])
      .value();
    return (
      <div className={classnames(['MediaCarousel-carousel', layout])}>
        {!isEmpty(galleryList) &&
          galleryList.map((item, index) => this.renderMediaType(item, index))}
      </div>
    );
  }
  render() {
    const { /*media,*/ layout } = this.props;
    return (
      <div className={classnames(['MediaCarousel', layout])}>
        {this.renderSlider()}
      </div>
    );
  }
}

export default MediaCarousel;
